/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AdMediaResponseDto = {
  /**
   * 미디어 URL
   */
  url: string;
  /**
   * 미디어 타입
   */
  type: AdMediaResponseDto.type;
  /**
   * 랜딩 URL
   */
  landingUrl?: string;
  /**
   * MUX Video Asset ID
   */
  videoAssetId?: string;
  /**
   * 상단 배너 애드몹 우선 (COUPANG_IFRAME 전용)
   */
  admobFirst?: boolean;
  /**
   * MUX Video Playback ID
   */
  videoPlaybackId?: string;
};
export namespace AdMediaResponseDto {
  /**
   * 미디어 타입
   */
  export enum type {
    IMAGE = "IMAGE",
    VIDEO = "VIDEO",
    COUPANG_IFRAME = "COUPANG_IFRAME",
  }
}
